import { createSlice } from '@reduxjs/toolkit';
export interface IThemeReducer {
  darkMode: boolean;
}

const initialState: IThemeReducer = {
  darkMode: true,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    switchTheme(state: IThemeReducer) {
      state.darkMode = !state.darkMode;
    },
  },
});

export const { switchTheme } = themeSlice.actions;

export const ThemeReducer = themeSlice.reducer;
